import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import * as authActions from 'redux/modules/auth';
import { translate } from 'react-i18next';

@translate(['common'])
@connect(
  state => ({ user: state.auth.user }),
  authActions)
export default class Admin extends Component {


  handleSubmit = (event) => {
    event.preventDefault();
    const input = this.refs.username;
    this.props.login(input.value);
    input.value = '';
  }

  render() {
    const { user, logout, t } = this.props;
    const styles = require('./Admin.scss');
    return (
      <div className={styles.loginPage + ' container'}>
        <Helmet title="Admin" />
        <h2>{t("admin.page_admin")}</h2>
        <p></p>


      </div>
    );
  }
}
